<template>
  <div class="container py-4">
    <h2 class="text-center text-primary mb-4 shadow-sm border py-3 rounded">Reservas</h2>

    <button v-show="showView == 'nuevaReserva'" class="btn btn-success" @click="showView = 'reservas'">Reservas</button>
    <button v-show="showView == 'reservas'" class="btn btn-success" @click="showView = 'nuevaReserva'">Nueva Reservas</button>
    <div v-show="loadingStep == 4 && showView == 'nuevaReserva'"
      :style="'color: black; max-width: 100vw; font-size: 0.8rem; min-height: calc(100vh - 125px);'">

      <div class="mx-auto rounded shadow" style=""
        :style="'width: 650px; height: 100%; z-index: 10; background: #0b0f12;'">

        <!-- START -->
        <!-- START -->
        <div v-if="reservasStep == 0" class="position-relative step-1">
          <div class="container-2 p-3 d-flex flex-column" style="overflow-y: auto;">
            <h4 class="text-center"><u>Reservas - Refugio Napostá</u></h4>
            <div>
              <label>Apellido y Nombre</label>
              <input class="form-control" v-model="apellido_nombre" />
              <label class="">Teléfono/Whatsapp</label>
              <input class="form-control" type="number" step="1" v-model="telefono" />
              <label class="">Email</label>
              <input class="form-control" type="text" step="1" v-model="email" />
            </div>

            <div class="text-start">
              <label for="cantidadPersonas" class="form-label">Cantidad de personas mayores de
                10
                años</label>
              <input type="number" id="cantidadPersonas" v-model="cantidadPersonas" class="form-control" min="1">
            </div>

            <div class="text-start my-1">
              <label for="cantidadMenores" class="form-label">Cantidad de menores de 10
                años</label>
              <input type="number" id="cantidadMenores" v-model="cantidadMenores" class="form-control" min="0">
              <small>(Los menores de 10 años no pagan estadía)</small>
            </div>

            <div>
              <label>Estadía</label><br />

              <input type="radio" id="acampa" value="acampa" name="estadia" v-model="estadia" />
              <label for="acampa" class="ms-1">Acampe</label>
              <br />
              <input type="radio" id="alquila" value="alquila" name="estadia" v-model="estadia" />
              <label for="alquila" class="ms-1">Habitación</label>
              <br />
              <input type="radio" id="alquilaAcampa" value="alquilaAcampa" name="estadia" v-model="estadia" />
              <label for="alquilaAcampa" class="ms-1">Habitación + Acampe</label>
              <br />
              <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#reservaModal">
                Reservas Exclusivas. Grupos mas de 30 personas
              </button>
            </div>
            <div>
              <button class="btn btn-success float-end mt-2" type="button" @click="reservasNextStep">Siguiente</button>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>


        <!-- CALENDAR -->
        <div v-if="reservasStep == 1" class="position-relative step-2">
          <div class="container-2" style="overflow-y: auto;">
            <div class="p-3 px-0" style="height: auto;">

              <h3 class="text-white">Seleccioná las noches de estadía</h3>
              <ComponentCalendar :fechasDisponibles="fechasDisponibles" :diasSeleccionados="diasSeleccionados"
                @toggle-day="handleDayClick" />

              <button class="btn btn-primary float-start mt-3 ms-3 btn-ml" @click="reservasPreviousStep">Volver</button>
              <div v-if="diasSeleccionados.length" class="pt-3" style="min-height: 50px;">
                <button class="btn btn-success float-end btn-mr me-3" type="button"
                  @click="reservasNextStep">Siguiente</button>

                <!-- Esto no se donde ponerlo -->
                <div v-if="false" class="row" style="">
                  <div v-for="dia in diasSeleccionados" class="col-4 text-center" :key="dia">
                    <p class="mb-0 text-nowrap" style="">{{ dia }}</p>
                  </div>
                </div>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>

        </div>

        <!-- END -->
        <div v-if="reservasStep == 2" class="step-3">
          <div class="container-3 p-3">
            <div id="carouselHabitaciones" class="carousel slide" data-bs-ride="false">
              <div class="carousel-inner">
                <div v-for="(dia, index) in diasSeleccionadosDetalle" :key="'dias' + index" class="carousel-item"
                  :class="{ active: index === 0 }">
                  <h4 v-if="estadia != 'acampa'" class="text-center m-0">
                    <u>Seleccione las habitaciones que utilizará</u>
                  </h4>
                  <h4 v-else class="text-center m-0"><u>Seleccione la cantidad de personas
                      que
                      acampan</u></h4>
                  <div class="text-center mb-2 text-warning" style="font-size: 24px;">{{
                    dia.fecha.split('-').reverse().join('/') }}</div>

                  <div class="row">
                    <div v-if="dia.complejo1 && !dia.lleno1 && (estadia == 'alquila' || estadia == 'alquilaAcampa')"
                      class="col-12 col-md-12">
                      <div class="form-check form-switch mx-auto" style="width: fit-content;">
                        <input class="form-check-input" type="checkbox" :id="'complejo1' + index"
                          v-model="diasSeleccionadosDetalle[index].lugares.complejo1" @change="calcularCostoTotal">
                        <label :for="'complejo1' + index" class="form-check-label">Habitación para 6
                          personas</label>
                      </div>
                    </div>
                    <div v-if="dia.complejo2 && !dia.lleno2 && (estadia == 'alquila' || estadia == 'alquilaAcampa')"
                      class="col-12 col-md-12 mt-3">
                      <div class="form-check form-switch mx-auto" style="width: fit-content;">
                        <input class="form-check-input" type="checkbox" :id="'complejo2' + index"
                          v-model="diasSeleccionadosDetalle[index].lugares.complejo2" @change="calcularCostoTotal">
                        <label :for="'complejo2' + index" class="form-check-label">Habitación para 6
                          personas</label>
                      </div>
                    </div>
                    <div v-if="dia.complejo3 && !dia.lleno3 && (estadia == 'alquila' || estadia == 'alquilaAcampa')"
                      class="col-12 col-md-12 mt-3">
                      <div class="form-check form-switch mx-auto" style="width: fit-content;">
                        <input class="form-check-input" type="checkbox" :id="'complejo3' + index"
                          v-model="diasSeleccionadosDetalle[index].lugares.complejo3" @change="calcularCostoTotal">
                        <label :for="'complejo3' + index" class="form-check-label">Habitación para 9
                          personas</label>
                      </div>
                    </div>
                    <div v-if="dia.complejo4 && !dia.lleno4 && (estadia == 'alquila' || estadia == 'alquilaAcampa')"
                      class="col-12 col-md-12 mt-3">
                      <div class="form-check form-switch mx-auto" style="width: fit-content;">
                        <input class="form-check-input" type="checkbox" :id="'complejo4' + index"
                          v-model="diasSeleccionadosDetalle[index].lugares.complejo4" @change="calcularCostoTotal">
                        <label :for="'complejo4' + index" class="form-check-label">Habitación para 9
                          personas</label>
                      </div>
                    </div>
                    <div
                      v-if="dia.acampe && (cantidadPersonas + cantidadMenores + dia.llenoAcampe) <= dia.cantidadAcampe && (estadia == 'acampa' || estadia == 'alquilaAcampa')"
                      class="col-12 col-md-12 mt-3">
                      <div v-if="estadia != 'acampa'" class="text-center">
                        <label :for="'acampe' + index" class="form-label">Cantidad
                          de
                          personas en acampe</label>
                      </div>
                      <!--
                            <div class="text-center">
                            <small>(incluir solo a los mayores de 10 años)</small>
                            </div>
                            -->
                      <input class="form-control mx-auto" v-model="diasSeleccionadosDetalle[index].lugares.acampe"
                        type="number" step="1" style="width: 200px;" @keyup="calcularCostoTotal" :id="'acampe' + index"
                        @change="calcularCostoTotal" />
                    </div>
                  </div>
                </div>

                <!-- RESUMEN -->
                <div class="carousel-item item-reserva">
                  <h4 class="text-center"><u>Resumen</u></h4>
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Descripcion</th>
                          <th>Monto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(detalle, index) in resumen" :key="index">
                          <td>{{ detalle.fecha.split('-').reverse().join('/') }}
                          </td>
                          <td>{{ detalle.title }}</td>
                          <td>
                            <input v-model="detalle.monto" class="form-control" />
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>{{ cantidadMenores }} menores de 10 años</td>
                          <td>$0</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-end"><b>Monto Total</b></td>
                          <td>${{ costoTotal.toLocaleString() }}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-end">
                            Monto de Reserva <input v-model="porcentajeReserva" class="form-control" />
                          </td>
                          <td>${{ calcularReserva.toLocaleString() }}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-end"><b>Monto a pagar al llegar</b></td>
                          <td>${{ (costoTotal - calcularReserva).toLocaleString()
                          }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="text-center">
                    <button v-if="!makingReserva" class="btn btn-success mt-2" type="button" @click="reservaStore">Pagar
                      Reserva Ahora</button>
                    <button v-if="makingReserva" class="btn btn-success mt-2" type="button" disabled>
                      <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class=" mt-2">
              <button class="btn btn-primary float-start" @click="carrouselPrevious">Anterior</button>
              <button v-if="indexDiaSeleccionadoResumen != diasSeleccionadosDetalle.length"
                class="btn btn-success float-end" @click="carrouselNext">Siguiente</button>
              <div style="clear:both;"></div>
            </div>

          </div>
        </div>



      </div>
    </div>

    <div v-show="showView == 'reservas'" class="">

      <div class="d-flex justify-content-between mb-4">
        <button :class="'d-none btn btn-' + (showSlim ? 'success' : 'info')"
          @click="() => { this.showSlim = !this.showSlim; }">{{ showSlim ? '+ Info' : '- Info' }}</button>
        <button class="btn btn-secondary" @click="showArchivo = !showArchivo">
          {{ showArchivo ? 'Ver actuales' : 'Ver archivo' }}
        </button>
        <span>
          <select class="form-control" v-model="reservaStatus">
            <option value="">Todas las reservas</option>
            <option v-for="reserva_status in reserva_statuses" :value="reserva_status" :key="reserva_status">
              {{ reserva_status }}
            </option>
          </select>
        </span>
        <div class="d-flex">
          <input type="date" class="form-control" title="Desde" v-model="filterDesde" />
          <input type="date" class="form-control" title="Hasta" v-model="filterHasta" />
        </div>
        <input type="text" v-model="searchQuery" placeholder="Buscar por nombre, teléfono o fecha"
          class="form-control w-50" />
      </div>

      <table class="table table-hover table-striped table-bordered" v-if="!showSlim && !loading">
        <tbody class="reserva-box" style="border: 5px solid #D2B48C;"
          v-for="(reserva, indexReserva) in reservasVisibles" :key="indexReserva">
          <tr>
            <td colspan="7">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Observaciones..." v-model="reserva.observacion">
                <button class="btn btn-success" type="button"
                  @click="reservaUpdateObservacion(reserva)">Guardar</button>
              </div>
            </td>
          </tr>
          <tr class="table-dark">
            <th class="text-center">Apellido y Nombre</th>
            <th class="text-center">Teléfono</th>
            <th class="text-center">Cantidad Mayores</th>
            <th class="text-center">Cantidad Menores</th>
            <th class="text-center">Reserva</th>
            <th class="text-center">Falta</th>
            <th class="text-center">Total</th>
          </tr>
          <tr>
            <td class="text-center">{{ reserva.apellido_nombre }}</td>
            <td class="text-center">{{ reserva.telefono }}</td>
            <td class="text-center">{{ reserva.mayores }}</td>
            <td class="text-center">{{ reserva.menores }}</td>
            <td class="text-center">
              <div class="input-group">
                <span class="input-group-text">$</span>
                <input type="number" step="0.01" class="form-control" v-model="reserva.montoReserva">
                <button class="btn btn-success" @click="reservaUpdateMontoReserva(reserva)">
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
              </div>
            </td>
            <td class="text-center text-danger">${{ (reserva.costo - reserva.costo /
              reserva.porcentaje_reserva).toLocaleString() }}</td>
            <td class="text-center text-primary">${{ (reserva.costo).toLocaleString() }}</td>
          </tr>
          <tr class="table-secondary">
            <th class="text-center" colspan="2">Fechas</th>
            <th class="text-center">Habitación 1</th>
            <th class="text-center">Habitación 2</th>
            <th class="text-center">Habitación 3</th>
            <th class="text-center">Habitación 4</th>
            <th class="text-center">Acampe</th>
          </tr>
          <tr v-for="(dia, indexDia) in reserva.dias" :key="'dia' + indexDia">
            <template v-if="!isDateQuery(searchQuery) || (isDateQuery(searchQuery) && dia.fecha == searchQuery)">
              <td class="text-center table-primary" style="vertical-align: middle;" colspan="2">
                <p class="m-0">{{ dia.fecha.split('-').reverse().join('/') }}</p>
              </td>
              <td class="position-relative">
                <div :class="' text-white rounded w-fit-content px-3'" :style="(dia.lugares.complejo1 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                  ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                  {{ dia.lugares.complejo1 ? 'Sí' : 'No' }}
                </div>
              </td>
              <td class="position-relative">
                <div
                  :class="(dia.lugares.complejo2 ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                  :style="(dia.lugares.complejo2 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                    ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                  {{ dia.lugares.complejo2 ? 'Sí' : 'No' }}
                </div>
              </td>
              <td class="position-relative">
                <div
                  :class="(dia.lugares.complejo3 ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                  :style="(dia.lugares.complejo3 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                    ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                  {{ dia.lugares.complejo3 ? 'Sí' : 'No' }}
                </div>
              </td>
              <td class="position-relative">
                <div
                  :class="(dia.lugares.complejo4 ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                  :style="(dia.lugares.complejo4 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                    ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                  {{ dia.lugares.complejo4 ? 'Sí' : 'No' }}
                </div>
              </td>
              <td class="position-relative">
                <div :class="(dia.lugares.acampe ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                  :style="(dia.lugares.acampe ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                    ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                  {{ dia.lugares.acampe }}
                </div>
              </td>
            </template>
          </tr>
          <tr>
            <td colspan="4">
              <div class="input-group mb-3">
                <select class="form-control" v-model="reserva.status">
                  <option v-for="reserva_status in reserva_statuses" :value="reserva_status" :key="reserva_status">
                    {{ reserva_status }}
                  </option>
                </select>
                <button v-if="false" class="btn btn-success" @click="reservaUpdateStatus(reserva)">Guardar</button>
                <button class="btn btn-danger" @click="reservaCancelar(reserva)">Cancelar</button>
              </div>
            </td>
            <td colspan="3" :class="reserva.email == 'martin.santiago1@gmail.com' ? 'bg-warning' : ''">
              {{ reserva.payment_method }}<br />
              {{ reserva.email }}
            </td>
          </tr>
        </tbody>
      </table>

      <table v-if="false" class="table table-hover table-bordered">
        <tbody>
          <tr class="table-dark" style="position: sticky; top: 0px; z-index: 99; outline: 1px solid black;">
            <th class="text-center" style="outline: 1px solid black;">Fechas</th>
            <th class="text-center" style="outline: 1px solid black;">Habitación 1</th>
            <th class="text-center" style="outline: 1px solid black;">Habitación 2</th>
            <th class="text-center" style="outline: 1px solid black;">Habitación 3</th>
            <th class="text-center" style="outline: 1px solid black;">Habitación 4</th>
            <th class="text-center" style="outline: 1px solid black;">Acampe</th>
            <th class="text-center" style="outline: 1px solid black;">Teléfono</th>
            <th class="text-center" style="outline: 1px solid black;">Mayores</th>
            <th class="text-center" style="outline: 1px solid black;">Menores</th>
            <th class="text-center" style="outline: 1px solid black;">Pagado</th>
            <th class="text-center" style="outline: 1px solid black;">Falta</th>
            <th class="text-center" style="outline: 1px solid black;">Total</th>
            <th class="text-center" style="outline: 1px solid black;">Status</th>
            <th class="text-center" style="outline: 1px solid black;">Metodo Pago</th>
          </tr>
          <template v-for="(dia, indexDia) in filteredReservas" :key="'dia' + indexDia">
            <template v-if="!isDateQuery(searchQuery) || (isDateQuery(searchQuery) && dia.fecha == searchQuery)">
              <tr @click="toggleRow(indexDia)" :style="'cursor: pointer; '">
                <td class="text-center"
                  :style="'vertical-align: middle; ' + (activeRow == indexDia ? 'background: orange;' : '')">
                  <p class="m-0">{{ dia.fecha }}</p>
                </td>
                <td class="position-relative">
                  <div :class="(dia.lugares.complejo1 ? '' : '') + ' text-white rounded w-fit-content px-3'" :style="(dia.lugares.complejo1 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                    ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                    {{ dia.lugares.complejo1 ? 'Sí' : 'No' }}
                  </div>
                </td>
                <td class="position-relative">
                  <div
                    :class="(dia.lugares.complejo2 ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                    :style="(dia.lugares.complejo2 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                      ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                    {{ dia.lugares.complejo2 ? 'Sí' : 'No' }}
                  </div>
                </td>
                <td class="position-relative">
                  <div
                    :class="(dia.lugares.complejo3 ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                    :style="(dia.lugares.complejo3 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                      ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                    {{ dia.lugares.complejo3 ? 'Sí' : 'No' }}
                  </div>
                </td>
                <td class="position-relative">
                  <div
                    :class="(dia.lugares.complejo4 ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                    :style="(dia.lugares.complejo4 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                      ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                    {{ dia.lugares.complejo4 ? 'Sí' : 'No' }}
                  </div>
                </td>
                <td class="position-relative">
                  <div
                    :class="(dia.lugares.acampe ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                    :style="(dia.lugares.acampe ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                      ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                    {{ dia.lugares.acampe }}
                  </div>
                </td>
              </tr>

              <!-- RESERVAS -->

              <tr v-for="(reserva, indexReserva) in dia.reservas" :key="'reserva' + indexReserva"
                v-show="activeRow === indexDia" class="expandable-row">
                <td>{{ reserva.detalle.apellido_nombre }}</td>
                <td class="position-relative">
                  <div
                    :class="(reserva.dia.lugares.complejo1 ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                    :style="(reserva.dia.lugares.complejo1 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                      ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                    {{ reserva.dia.lugares.complejo1 ? 'Sí' : 'No' }}
                  </div>
                </td>
                <td class="position-relative">
                  <div
                    :class="(reserva.dia.lugares.complejo2 ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                    :style="(reserva.dia.lugares.complejo2 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                      ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                    {{ reserva.dia.lugares.complejo2 ? 'Sí' : 'No' }}
                  </div>
                </td>
                <td class="position-relative">
                  <div
                    :class="(reserva.dia.lugares.complejo3 ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                    :style="(reserva.dia.lugares.complejo3 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                      ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                    {{ reserva.dia.lugares.complejo3 ? 'Sí' : 'No' }}
                  </div>
                </td>
                <td class="position-relative">
                  <div
                    :class="(reserva.dia.lugares.complejo4 ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                    :style="(reserva.dia.lugares.complejo4 ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                      ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                    {{ reserva.dia.lugares.complejo4 ? 'Sí' : 'No' }}
                  </div>
                </td>
                <td class="position-relative">
                  <div
                    :class="(reserva.dia.lugares.acampe ? '' : '') + ' text-white rounded w-fit-content px-3 mx-auto my-auto'"
                    :style="(reserva.dia.lugares.acampe ? 'background-color: #28a745;' : 'background-color: #dc3545;') +
                      ' position:absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);'">
                    {{ reserva.dia.lugares.acampe }}
                  </div>
                </td>
                <td>
                  {{ reserva.detalle.telefono }}
                </td>
                <td>
                  {{ reserva.detalle.mayores }}
                </td>
                <td>
                  {{ reserva.detalle.menores }}
                </td>
                <td class="text-center text-success">
                  <div class="input-group mb-3">
                    <input type="number" step="0.01" class="form-control">
                    <button class="btn btn-success" type="button">
                      <i class="fa-solid fa-pen-to-square"></i>
                    </button>
                  </div>
                </td>
                <td class="text-center text-success">${{ (reserva.costo / reserva.porcentaje_reserva).toLocaleString()
                  }}</td>
                <td>
                  ${{ (reserva.detalle.costo).toLocaleString() }}
                </td>
                <td>
                  {{ reserva.status }}
                </td>
                <td>
                  <div class="d-flex">
                    <div v-if="!reserva.detalle.cancelada" style="cursor: pointer;" @click="reservaCancelar(reserva)">
                      <i class="fa-solid fa-trash-can"></i>
                    </div>
                    <div v-else title="Cancelada">
                      <i class="fa-solid fa-ban"></i>
                    </div>
                    {{ reserva.paymentMethod }}
                  </div>

                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
      <button @click="exportToCSV" class="btn btn-primary mt-4">Exportar a CSV</button>
    </div>
  </div>
</template>


<script>
import ComponentCalendar from "@/views/components/client/ComponentCalendar.vue";
import { mapActions } from 'vuex';
import { useToast } from "vue-toastification";
import { Carousel } from 'bootstrap';

const toast = useToast();
import Swal from "sweetalert2";

export default {
  name: 'ViewAdminReservas',
  components: { ComponentCalendar },
  data() {
    return {
      reservas: [],
      searchQuery: '',
      showSlim: false,
      fechasDisponiblesDetalle: [],
      activeRow: null,
      loading: true,
      showArchivo: false,
      reservaStatus: 'approved',
      filterDesde: null,
      filterHasta: null,

      // RESERVA
      indexDiaSeleccionadoResumen: 0,
      diasSeleccionados: [],
      diasSeleccionadosDetalle: [],
      cantidadPersonas: 1,
      fechasDisponibles: [],
      fechasDisponiblesDetalle2: [],
      porcentajeReserva: 0,
      hayMenores: false,
      cantidadMenores: 0,
      reservasStep: 0,
      lugares: {
        complejo1: false,
        complejo2: false,
        complejo3: false,
        complejo4: false,
        acampe: 0
      },
      costos: {
        complejo1: 20000,
        complejo2: 20000,
        complejo3: 40000,
        complejo4: 40000,
        acampe: 10000
      },
      //costoTotal: 0,
      resumen: [],
      estadia: '',
      apellido_nombre: '',
      telefono: '',
      telefonoWsp: '',
      email: '',
      photos: [],
      isMobile: false,
      fondoReservas: '',
      loadingStep: 0,
      makingReserva: false,
      accesoCerro: '',

      showView: 'reservas'
    };
  },
  computed: {
    costoTotal() {
      let total = 0;
      this.resumen.forEach((dia) => {
        total += Number(dia.monto);
      });

      return total;
    },
    filteredReservas() {
      if (!this.reservas || !Array.isArray(this.reservas)) return [];

      let reservas = [...this.reservas]; // Evita modificar el original
      let reservasResult = [];

      if (!this.showSlim) {

        reservasResult = reservas.filter(reserva => {
          const nombreMatch = reserva.apellido_nombre?.toLowerCase().includes(this.searchQuery?.toLowerCase() || "");
          const telefonoMatch = reserva.telefono?.includes(this.searchQuery || "");
          const fechaMatch = Array.isArray(reserva.dias) && reserva.dias.some(dia => dia.fecha?.includes(this.searchQuery || ""));
          return nombreMatch || telefonoMatch || fechaMatch;
        });
      } else {

        // Query Search
        let result = reservas.filter(reserva => {
          const nombreMatch = reserva.apellido_nombre.toLowerCase().includes(this.searchQuery.toLowerCase()) ? true : false;
          const telefonoMatch = reserva.telefono.includes(this.searchQuery) ? true : false;
          const fechaMatch = Array.isArray(reserva.dias) && reserva.dias.some(dia => dia.fecha?.includes(this.searchQuery || ""));
          console.log(nombreMatch);
          console.log(telefonoMatch);
          console.log(fechaMatch);
          return nombreMatch || telefonoMatch || fechaMatch;
        });

        // Agregamos cancelada a la reserva
        result.forEach((element, index) => {
          result[index].dias.forEach((elementDia, indexDia) => {
            result[index].dias[indexDia].cancelada = result[index].cancelada;
          });
        });

        // Nuevo array con las reservas
        let finalResult = result.flatMap(reserva => reserva.dias || []);

        let merged = [];

        // Esto para la tabla general
        this.fechasDisponiblesDetalle.forEach(diaHabilitado => {
          merged.push({
            fecha: diaHabilitado.fecha,
            lugares: {
              complejo1: false,
              complejo2: false,
              complejo3: false,
              complejo4: false,
              acampe: 0
            },
            reservas: []
          });
        });

        // Esto para el la sub tabla de cada fecha
        finalResult.forEach(entry => {
          if (!entry || !entry.fecha || !entry.lugares) return;

          let findMergedIndex = merged.findIndex(el => el.fecha === entry.fecha);

          //console.log('entry: ', entry)

          if (findMergedIndex != -1) {
            Object.keys(entry.lugares).forEach(key => {
              if (typeof entry.lugares[key] === 'boolean') {
                merged[findMergedIndex].lugares[key] = merged[findMergedIndex].lugares[key] || (!entry.cancelada && entry.lugares[key]);
              } else if (typeof entry.lugares[key] === 'number') {
                merged[findMergedIndex].lugares[key] = (merged[findMergedIndex].lugares[key] || 0) + (entry.cancelada == 0 ? entry.lugares[key] : 0);
              }
            });
          }
        });

        result.forEach(reserva => {
          //console.log('reserva: ', reserva)
          reserva.dias.forEach(diaReserva => {

            let findMergedIndex = merged.findIndex(el => el.fecha === diaReserva.fecha);

            if (findMergedIndex != -1) {
              merged[findMergedIndex].reservas.push({
                detalle: reserva,
                dia: diaReserva,
                status: reserva.status,
                paymentMethod: reserva.payment_method
              });
            }

          });
        });

        if (this.searchQuery) {
          merged = merged.filter(item => item.reservas.length > 0);
        }
      }

      if (this.reservaStatus) {
        console.log('this.reservaStatus: ', this.reservaStatus);
        reservasResult = reservasResult.filter(el => el.status == this.reservaStatus);
      }

      reservasResult = reservasResult
        // 1. ordenar cada reservas.dias internamente
        .map(reserva => {
          reserva.dias.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
          return reserva;
        })
        // 2. filtrar por rango si existen filtros
        .filter(reserva => {
          if (!this.filterDesde && !this.filterHasta) return true;

          const fechaInicioReserva = new Date(reserva.dias[0].fecha);
          const fechaFinReserva = new Date(reserva.dias[reserva.dias.length - 1].fecha);

          if (this.filterDesde) {
            const desde = new Date(this.filterDesde);
            if (fechaFinReserva < desde) return false;
          }
          if (this.filterHasta) {
            const hasta = new Date(this.filterHasta);
            if (fechaInicioReserva > hasta) return false;
          }
          return true;
        })
        // 3. ordenar reservas por la fecha más antigua de sus dias
        .sort((a, b) => {
          const fechaA = new Date(a.dias[0].fecha);
          const fechaB = new Date(b.dias[0].fecha);
          return fechaA - fechaB;
        });

      console.log('reservasResult: ', reservasResult);

      return reservasResult;
    },
    reservasVisibles() {

      if (!Array.isArray(this.filteredReservas)) {
        return []
      }

      const limite = new Date()
      limite.setHours(0, 0, 0, 0)
      limite.setDate(limite.getDate() - 10)

      let result = this.filteredReservas.filter(reserva => {

        if (this.showSlim) {
          return true
        }

        if (!Array.isArray(reserva.dias)) {
          return false
        }

        const tieneDiaValido = reserva.dias.some(dia => {
          const fecha = new Date(dia.fecha)
          fecha.setHours(0, 0, 0, 0)
          return fecha >= limite
        })

        return this.showArchivo
          ? !tieneDiaValido
          : tieneDiaValido

      });



      return result

    },
    reserva_statuses() {
      let reserva_statuses = [];

      this.reservas.forEach(reserva => {
        if (!reserva_statuses.find(el => el == reserva.status)) {
          reserva_statuses.push(reserva.status);
        }
      });

      return reserva_statuses;
    },
    calcularReserva() {
      return (this.costoTotal * this.porcentajeReserva) / 100;
    },
  },
  watch: {
    estadia() {
      this.calcularDiasDisponibles();
    },
    cantidadPersonas() {
      this.calcularDiasDisponibles();
    },
    cantidadMenores() {
      this.calcularDiasDisponibles();
    }
  },
  async mounted() {

    this.diaHabilitadoGetHabilitados().then(() => { this.loadingStep += 1 });
    this.precioPorcentajeReserva().then(() => { this.loadingStep += 1 });
    //this.galeriaGetPhotos().then(() => { this.loadingStep += 1 });
    this.variableGetByName('fondoReservas').then(() => { this.loadingStep += 1 });
    //this.variableGetByName('accesoCerro').then(() => { this.loadingStep += 1 });
    this.variableGetByName('telefono').then(() => { this.loadingStep += 1 });

    await this.reservaGetAll();
    await this.diaHabilitadoGetAll();
    this.loading = false;
  },
  methods: {
    ...mapActions('reserva', ['reserva_getAll', 'reserva_cancelar', 'reserva_updateObservacion', 'reserva_updateMontoReserva', 'reserva_updateStatus']),
    ...mapActions('diaHabilitado', ['diaHabilitado_getAll']),
    ...mapActions('reserva', ['reserva_store']),
    ...mapActions('precio', ['precio_getPorcentajeReserva']),
    ...mapActions('diaHabilitado', ['diaHabilitado_getHabilitados']),
    ...mapActions('variable', ['variable_getByName']),
    async diaHabilitadoGetAll() {
      try {
        let response = await this.diaHabilitado_getAll();

        if (response.status == 200) {

          this.fechasDisponiblesDetalle = response.data.diasHabilitados;
          //console.log('fechasDisponiblesDetalle: ', this.fechasDisponiblesDetalle);

        }
      } catch (error) {
        console.log(error);
        toast.error('Error obteniendo dias habilitados');
      }
    },
    async reservaGetAll() {
      try {
        let response = await this.reserva_getAll();

        if (response.status == 200) {
          this.reservas = response.data.reservas;
          this.reservas.forEach((element, index) => {
            this.reservas[index]['dias'] = JSON.parse(this.reservas[index]['dias']);
            this.reservas[index]['montoReserva'] = this.reservas[index]['monto_reserva'] ? this.reservas[index]['monto_reserva'] : this.reservas[index].costo / this.reservas[index].porcentaje_reserva;
          });
        }

      } catch (error) {
        console.log(error);
        toast.error('Error obteniendo las reservas');
      }
    },
    exportToCSV() {
      // Crear el contenido del CSV
      let csvContent = "data:text/csv;charset=utf-8,";

      if (!this.showSlim) {
        this.filteredReservas.forEach(reserva => {
          // Encabezados de las filas principales
          csvContent += "Apellido y Nombre,Teléfono,Cantidad Mayores,Cantidad Menores,Reserva,Total\n";
          // Extraer información básica de la reserva
          const reservaRow = [
            reserva.apellido_nombre,
            reserva.telefono,
            reserva.mayores,
            reserva.menores,
            (reserva.costo / reserva.porcentaje_reserva).toLocaleString(),
            reserva.costo.toLocaleString()
          ].join(","); // Concatena los valores de la fila principal

          // Agregar la fila principal
          csvContent += reservaRow + "\n"; // Agregar la fila principal

          // Agregar encabezados para las fechas solo una vez por reserva
          csvContent += "Fechas,Habitacion 1,Habitacion 2,Habitacion 3,Habitacion 4,Acampe\n";

          reserva.dias.forEach(dia => {
            const diaRow = [
              dia.fecha,
              dia.lugares.complejo1 ? 'Si' : 'No',
              dia.lugares.complejo2 ? 'Si' : 'No',
              dia.lugares.complejo3 ? 'Si' : 'No',
              dia.lugares.complejo4 ? 'Si' : 'No',
              dia.lugares.acampe
            ].join(",");

            // Agregar cada fila de día
            csvContent += diaRow + "\n";
          });

          // Agregar una línea en blanco entre reservas
          csvContent += "\n";
        });
      } else {

        csvContent += "Fechas,Habitacion 1,Habitacion 2,Habitacion 3,Habitacion 4,Acampe,Telefono,Mayores,Menores,Pagado,Falta,Total\n";

        // Iterar sobre los días
        this.filteredReservas.forEach(dia => {
          // Agregar la fila del día
          const diaRow = [
            dia.fecha,
            dia.lugares.complejo1 ? 'Si' : 'No',
            dia.lugares.complejo2 ? 'Si' : 'No',
            dia.lugares.complejo3 ? 'Si' : 'No',
            dia.lugares.complejo4 ? 'Si' : 'No',
            dia.lugares.acampe
          ].join(",");

          // Agregar la fila del día al CSV
          csvContent += diaRow + "\n";

          // Ahora agregamos las reservas correspondientes a este día
          dia.reservas.forEach(reserva => {
            const reservaRow = [
              reserva.detalle.apellido_nombre,
              reserva.dia.lugares.complejo1 ? 'Si' : 'No',
              reserva.dia.lugares.complejo2 ? 'Si' : 'No',
              reserva.dia.lugares.complejo3 ? 'Si' : 'No',
              reserva.dia.lugares.complejo4 ? 'Si' : 'No',
              reserva.dia.lugares.acampe,
              reserva.detalle.telefono,
              reserva.detalle.mayores,
              reserva.detalle.menores,
              (reserva.detalle.costo / reserva.detalle.porcentaje_reserva).toLocaleString(),
              (reserva.detalle.costo - (reserva.detalle.costo / reserva.detalle.porcentaje_reserva)).toLocaleString(),
              reserva.detalle.costo.toLocaleString()
            ].join(",");

            // Agregar cada fila de reserva
            csvContent += reservaRow + "\n";
          });

          // Agregar una línea en blanco entre los días
          csvContent += "\n";
        });
      }


      // Crear un enlace y descargar el archivo CSV
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "reservas.csv");
      document.body.appendChild(link); // Necesario para Firefox

      link.click(); // Inicia la descarga
      document.body.removeChild(link); // Elimina el enlace
    },
    isDateQuery(query) {
      const date = new Date(query);
      return !isNaN(date.getTime());
    },
    toggleRow(index) {
      this.activeRow = this.activeRow === index ? null : index;
    },
    async reservaCancelar(reserva) {
      try {

        const result = await Swal.fire({
          title: "¿Confirmar cancelación?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, cancelar",
          cancelButtonText: "No, volver",
        });

        if (result.isConfirmed) {

          let response = await this.reserva_cancelar({ id: reserva.id });

          if (response.status == 200) {
            toast.success('Reserva cancelada con éxito');
            window.location.reload();
          }

        }
      } catch (error) {
        console.log(error);
        toast.error('Error al intentar cancelar la reserva');
      }

    },
    getFechaMasReciente(reserva) {

      if (!reserva.dias || reserva.dias.length === 0) {
        return new Date(0)
      }

      let max = reserva.dias[0].fecha

      reserva.dias.forEach(dia => {
        if (dia.fecha > max) {
          max = dia.fecha
        }
      })

      return new Date(max)

    },
    async reservaUpdateObservacion(reserva) {
      try {
        let response = await this.reserva_updateObservacion({ id: reserva.id, observacion: reserva.observacion })

        if (response.status == 200) {
          toast.success('Observacion actualizada con éxito');
        }

      } catch (error) {
        console.log(error);
        toast.error('Error al guardar observacion');
      }
    },
    async reservaUpdateMontoReserva(reserva) {
      const result = await Swal.fire({
        icon: 'question',
        title: '¿Confirmar cambios?',
        text: '¿Desea confirmar los cambios en el monto de la reserva?',
        showCancelButton: true,
        confirmButtonText: 'Sí, guardar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      });

      if (!result.isConfirmed) return;

      try {
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading()
        });

        let response = await this.reserva_updateMontoReserva({
          id: reserva.id,
          montoReserva: reserva.montoReserva
        });

        Swal.close();
        if (response.status == 200) {
          toast.success('Monto reserva actualizado con éxito');
        }
      } catch (error) {
        Swal.close();
        console.log(error);
        toast.error('Error al guardar monto reserva');
      }
    },
    async reservaUpdateStatus(reserva) {
      const result = await Swal.fire({
        icon: 'warning',
        title: '¿Cambiar status?',
        html: 'Cambiar el status no afectará a la disponibilidad en el calendario<br/><br/>Recrdá luego cambiar la disponibilidad correspondiente en <b>Fechas</b><br/><br/>¿Desea continuar?',
        showCancelButton: true,
        confirmButtonText: 'Sí, cambiar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      });

      if (!result.isConfirmed) return;

      try {

        Swal.fire({
          title: 'Actualizando...',
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading()
        });

        let response = await this.reserva_updateStatus({
          id: reserva.id,
          status: reserva.status
        });

        Swal.close();
        if (response.status == 200) {
          toast.success('Status actualizado con éxito');
        }

      } catch (error) {
        Swal.close();
        console.log(error);
        toast.error('Error al guardar status');
      }
    },

    // NEW RESERVA
    handleDayClick(dia) {
      if (this.diasSeleccionados.includes(dia)) {
        this.diasSeleccionados = this.diasSeleccionados.filter(d => d !== dia);
      } else {
        this.diasSeleccionados.push(dia);
      }
      this.diasSeleccionados = this.diasSeleccionados.sort();
    },
    reservasNextStep() {
      if (this.reservasStep == 1) {
        /*
        if (this.tieneDiasPerdidos()) {
          toast.error('Su selección de días tiene huecos. Necesitará hacer 2 reservas diferentes sin dias intermedios vacios');
          return;
        }
        */

        this.diasSeleccionadosDetalle = [];
        this.diasSeleccionados.forEach(dia => {
          let fechaDisponible = this.fechasDisponiblesDetalle2.find(el => el.fecha == dia);

          fechaDisponible.lugares = {
            complejo1: false,
            complejo2: false,
            complejo3: false,
            complejo4: false,
            acampe: this.estadia == 'acampa' ? this.cantidadPersonas + this.cantidadMenores : 0
          };
          this.diasSeleccionadosDetalle.push(
            fechaDisponible
          );
          this.calcularCostoTotal();

        });
      }
      if (this.reservasStep == 0) {
        if (!this.apellido_nombre) {
          toast.error('Debe ingresar un nombre');
          return;
        }
        if (!this.telefono) {
          toast.error('Debe ingresar un teléfono');
          return;
        }

        if (this.cantidadPersonas <= 0) {
          toast.error('La cantidad de personas mayores debe ser mayor a 0');
          return;
        }
        if (!this.estadia) {
          toast.error('Debe seleccionar una opción de estadía');
          return;
        }
        if (!this.email) {
          toast.error('Debe ingresar un email');
          return;
        }
        if (this.cantidadMenores > 5) {
          toast.error('La cantidad de menores de ser menor o igual a 5')
          return;
        }
        this.diasSeleccionados = [];
        this.diasSeleccionadosDetalle = [];
      }
      this.reservasStep += 1;
    },
    calcularCostoTotal() {
      let accesoCerro = this.diasSeleccionadosDetalle[0].accesoCerro;
      console.log('this.diasSeleccionadosDetalle: ', this.diasSeleccionadosDetalle);
      this.resumen = [];
      this.diasSeleccionadosDetalle.forEach((diaSeleccionadoDetalle) => {
        //console.log('diaSeleccionadoDetalle: ',diaSeleccionadoDetalle);
        if (diaSeleccionadoDetalle.lugares.complejo1) {
          this.resumen.push({
            title: 'Habitacion 1',
            fecha: diaSeleccionadoDetalle.fecha.split('-').reverse().join('/'),
            monto: diaSeleccionadoDetalle.monto1
          });
        }
        if (diaSeleccionadoDetalle.lugares.complejo2) {
          this.resumen.push({
            title: 'Habitacion 2',
            fecha: diaSeleccionadoDetalle.fecha.split('-').reverse().join('/'),
            monto: diaSeleccionadoDetalle.monto2
          });
        }
        if (diaSeleccionadoDetalle.lugares.complejo3) {
          this.resumen.push({
            title: 'Habitacion 3',
            fecha: diaSeleccionadoDetalle.fecha.split('-').reverse().join('/'),
            monto: diaSeleccionadoDetalle.monto3
          });
        }
        if (diaSeleccionadoDetalle.lugares.complejo4) {
          this.resumen.push({
            title: 'Habitacion 4',
            fecha: diaSeleccionadoDetalle.fecha.split('-').reverse().join('/'),
            monto: diaSeleccionadoDetalle.monto4
          });
        }

        if (diaSeleccionadoDetalle.lugares.acampe) {
          this.resumen.push({
            title: diaSeleccionadoDetalle.lugares.acampe + ' personas en acampe',
            fecha: diaSeleccionadoDetalle.fecha.split('-').reverse().join('/'),
            monto: diaSeleccionadoDetalle.montoAcampe * diaSeleccionadoDetalle.lugares.acampe
          });
        }

        if (diaSeleccionadoDetalle.accesoCerro < accesoCerro) {
          accesoCerro = diaSeleccionadoDetalle.accesoCerro;
        }
      });

      if (accesoCerro) {
        this.resumen.push({
          title: this.cantidadPersonas + ' Acceso al Cerro',
          fecha: '',
          monto: this.cantidadPersonas * accesoCerro
        });
      }
      console.log('resumen: ', this.resumen);
    },
    reservasPreviousStep() {
      if (this.reservasStep != 0) {
        this.reservasStep -= 1;
      }
    },
    tieneDiasPerdidos() {
      if (this.diasSeleccionados.length < 2) return false;

      let start = this.diasSeleccionados[0];
      let end = this.diasSeleccionados[this.diasSeleccionados.length - 1];

      let indexStart = this.fechasDisponibles.indexOf(start);
      let indexEnd = this.fechasDisponibles.indexOf(end);

      let cantidadRequerida = indexEnd - indexStart + 1;

      if (cantidadRequerida != this.diasSeleccionados.length) {
        return true;
      }

      return false;
    },
    async reservaStore() {
      try {

        let flagCompleto = true;
        let fecha = { fecha: '', faltante: 0 };
        this.diasSeleccionadosDetalle.forEach(diaSeleccionado => {

          let cantidadSolicitada = 0;
          if (diaSeleccionado.lugares.complejo1) {
            cantidadSolicitada += diaSeleccionado.cantidad1;
          }
          if (diaSeleccionado.lugares.complejo2) {
            cantidadSolicitada += diaSeleccionado.cantidad2;
          }
          if (diaSeleccionado.lugares.complejo3) {
            cantidadSolicitada += diaSeleccionado.cantidad3;
          }
          if (diaSeleccionado.lugares.complejo4) {
            cantidadSolicitada += diaSeleccionado.cantidad4;
          }
          if (diaSeleccionado.lugares.acampe) {
            cantidadSolicitada += diaSeleccionado.lugares.acampe;
          }

          if (cantidadSolicitada < (this.cantidadPersonas + this.cantidadMenores)) {
            flagCompleto = false;
            fecha.fecha = diaSeleccionado.fecha;
            fecha.faltante = (this.cantidadPersonas + this.cantidadMenores) - cantidadSolicitada;
          }
        });

        if (!flagCompleto) {
          toast.error('A la fecha ' + fecha.fecha.split('-').reverse().join('/') + ' le falta asignar ' + fecha.faltante + ' personas');
          return;
        }

        this.makingReserva = true;

        let response = await this.reserva_store({
          diasSeleccionadosDetalle: this.diasSeleccionadosDetalle,
          apellido_nombre: this.apellido_nombre,
          telefono: this.telefono,
          email: this.email,
          costo: this.costoTotal,
          mayores: this.cantidadPersonas,
          menores: this.cantidadMenores,
          porcentajeReserva: this.porcentajeReserva,
          resumen: this.resumen,
          maker: 'admin'
        });

        if (response.data.message == 'admin') {
          Swal.fire({
            icon: 'success',
            title: 'Reserva realizada con éxito',
            text: 'Serás redirigido o puedes recargar la página.',
            confirmButtonText: 'Aceptar'
          }).then(() => {
            window.location.reload();
          });
        } else {
          toast.error('Error haciendo reserva');
        }

      } catch (error) {
        console.log(error);
        toast.error('Error haciendo reserva');
      }
    },
    async diaHabilitadoGetHabilitados() {
      try {
        let response = await this.diaHabilitado_getHabilitados({ client: true });
        console.log('diaHabilitadoGetHabilitados: ', response);
        if (response.status == 200) {

          this.fechasDisponiblesDetalle2 = response.data.diasHabilitados;


        }
      } catch (error) {
        console.log(error);
        toast.error('Error obteniendo dias habilitados');
      }
    },
    async precioPorcentajeReserva() {
      try {
        let response = await this.precio_getPorcentajeReserva();

        if (response.status == 200) {
          this.porcentajeReserva = response.data.porcentaje_reserva.value;
        }
      } catch (error) {
        console.log(error);
        toast.error('Error obteniendo el porcentaje de reserva');
      }
    },
    carrouselNext() {
      let carouselInstance = new Carousel(document.getElementById('carouselHabitaciones'));
      let lugaresOcupados = 0;
      if (this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.complejo1) {
        lugaresOcupados += this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].cantidad1;
      }
      if (this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.complejo2) {
        lugaresOcupados += this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].cantidad2;
      }
      if (this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.complejo3) {
        lugaresOcupados += this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].cantidad3;
      }
      if (this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.complejo4) {
        lugaresOcupados += this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].cantidad4;
      }
      if (this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.acampe) {
        lugaresOcupados += this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.acampe;
      }

      if (lugaresOcupados < (this.cantidadPersonas)) {
        toast.error("La selección no completa la cantidad personas");
      } else {
        carouselInstance.next();
        this.indexDiaSeleccionadoResumen += 1;
      }
    },
    carrouselPrevious() {
      if (this.indexDiaSeleccionadoResumen == 0) {
        this.reservasStep -= 1;
      } else {
        let carouselInstance = new Carousel(document.getElementById('carouselHabitaciones'));
        carouselInstance.prev();
        this.indexDiaSeleccionadoResumen -= 1;
      }

    },
    calcularDiasDisponibles() {
      this.fechasDisponibles = [];
      this.fechasDisponiblesDetalle2.forEach(fechaDisponible => {

        let cantidad = this.cantidadMenores + this.cantidadPersonas;

        let cantidadAlquilaAcampa = 0;
        if (fechaDisponible.complejo1 && !fechaDisponible.lleno1) cantidadAlquilaAcampa += fechaDisponible.cantidad1;
        if (fechaDisponible.complejo2 && !fechaDisponible.lleno2) cantidadAlquilaAcampa += fechaDisponible.cantidad2;
        if (fechaDisponible.complejo3 && !fechaDisponible.lleno3) cantidadAlquilaAcampa += fechaDisponible.cantidad3;
        if (fechaDisponible.complejo4 && !fechaDisponible.lleno4) cantidadAlquilaAcampa += fechaDisponible.cantidad4;
        if (fechaDisponible.acampe) cantidadAlquilaAcampa += fechaDisponible.cantidadAcampe - fechaDisponible.llenoAcampe;

        let cantidadAlquila = 0;
        if (fechaDisponible.complejo1 && fechaDisponible.lleno1 == 0) cantidadAlquila += fechaDisponible.cantidad1;
        if (fechaDisponible.complejo2 && fechaDisponible.lleno2 == 0) cantidadAlquila += fechaDisponible.cantidad2;
        if (fechaDisponible.complejo3 && fechaDisponible.lleno3 == 0) cantidadAlquila += fechaDisponible.cantidad3;
        if (fechaDisponible.complejo4 && fechaDisponible.lleno4 == 0) cantidadAlquila += fechaDisponible.cantidad4;

        let cantidadAcampa = fechaDisponible.cantidadAcampe - fechaDisponible.llenoAcampe;

        let habilitado = true;

        if (this.estadia == 'acampa') {
          if (cantidad > cantidadAcampa || !fechaDisponible.acampe) {
            habilitado = false;
          }
        }
        if (this.estadia == 'alquilaAcampa') {
          if (cantidad > cantidadAlquilaAcampa) {
            habilitado = false;
          }
        }

        if (this.estadia == 'alquila') {
          if (cantidad > cantidadAlquila) {
            habilitado = false;
          }
        }

        if (habilitado) {
          this.fechasDisponibles.push(fechaDisponible.fecha);
        } else {
          this.fechasDisponibles.push('!' + fechaDisponible.fecha);
        }
      });
    },
    async variableGetByName(nombre) {
      try {
        let response = await this.variable_getByName({ nombre: nombre });

        if (response.status == 200) {
          if (nombre == 'telefono') {
            this.telefonoWsp = response.data.value;
          } else {
            this[nombre] = response.data.value;
          }
        }

      } catch (error) {
        console.log(error);
        toast.error('Error obteniendo variable');
      }
    },
  },

};
</script>
<style scoped>
/* Animación de deslizamiento */
.expandable-row {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;

}

.expandable-row[v-show="true"] {
  max-height: 100px;
  /* Ajusta según el contenido */

}

.expandable-row td {
  background-color: #e8f7ff;
}

.reserva-box {
  border: 2px solid #D2B48C;
}

.reserva-box tr td {
  border: 1px solid gray;
  /* opcional para limpiar */
}

/* RESERVAS */
.container-2 {
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  position: absolute;
  width: 400px;
  max-width: 100vw;
  font-family: 'Poppins', sans-serif;

  color: white;
}

.container-2 h4,
.container-2 label,
.container-3 h4 {
  font-family: 'Poppins', sans-serif;
  color: white;

}

.container-3 th {
  background-color: #8B572A;
}

.container-3 td {
  background-color: #A66A3A;
}

.container-3 td,
.container-3 th {
  color: white;
}

table {
  border: 1px black solid;
}

.container-3 {
  width: 400px;
  margin-left: auto;
  margin-right: auto;
  ;
  font-family: 'Poppins', sans-serif;
  color: white;
}

.slider {
  height: calc(100vh - 125px);
}

h3 {
  text-align: center;
  color: #3a3a3a;
}

.dias-seleccionados-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  /* Espacio entre elementos */
}

.dia-seleccionado {
  background-color: #e0e0e0;
  padding: 5px 10px;
  border-radius: 5px;
  white-space: nowrap;
  /* Evita que los textos se dividan en dos líneas */
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* Ajusta la opacidad (0.5 es 50%) */
}

.bg-white {
  background-color: whitesmoke !important;
}

.general-container {
  width: 100vw;
  margin-left: calc(-1 * (100vw - 100%));
  /* Ajusta el margen para contrarrestar el scroll */
}

.general-container .col-md-6 {
  padding-left: 0;
  padding-right: 0;
}

@media (max-width: 767px) {
  .col-12 {
    padding: 0 !important;
  }

  .step-1 {
    height: 500px !important;
  }

  .step-2 {
    height: 500px !important;
  }

  .step-2 .container-2 {
    width: 520px;
    padding: 0px;
  }

  .item-reserva {}

  .container-2 {
    padding: 10px;
  }

  .container-2 h4,
  .container-2 label,
  .container-3,
  .container-3 h4 {
    text-align: center;
  }

  .container-3 {
    max-width: 100vw;
  }

  .slider {
    height: 500px;
  }

  .btn-ml {
    margin-left: 10px;
  }

  .btn-mr {
    margin-right: 10px;
  }
}

@media (min-width: 768px) {

  .step-1 .container-2,
  .step-2 .container-2,
  .step-3 .container-3 {
    padding-top: 20px !important;
    padding-bottom: 50px;
    height: calc(100vh - 125px);
  }

  .step-2 .container-2 {
    max-width: calc((100vw / 12) x 5);
    width: 520px;
  }

  .step-1,
  .step-2,
  .step-3 {
    height: calc(100vh - 125px);
  }

  .item-reserva {
    overflow-y: auto;
  }

  .step-3 .container-3 {
    width: 500px;
    max-width: calc((100vw / 12) x 5);
  }
}

button {
  font-size: 0.8rem;
}
</style>
